<!-- 外部价格新增页面 -->
<template>
  <div class="addoutsidePrice">
    <div class="tableStyle">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        :edit-actived="activeIndex"
        :auto-resize="true"
        :data="tableData"
        :edit-rules="tableRules"
        :toolbar="tableToolbar"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @cell-click="getActiveIndex"
      >
        <vxe-table-column type="checkbox" width="50"></vxe-table-column>
        <vxe-table-column type="seq" :title="$t('table.index')" width="50"></vxe-table-column>
        <!-- 创建日期 -->
        <vxe-table-column
          field="priceCreateTime"
          width="180px"
          :title="
            isHnFlag
              ? $t('outsidePrice.label.priceCreateTimeHn')
              : $t('outsidePrice.label.priceCreateTime')
          "
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="scope">
            <el-date-picker
              v-model="scope.row.priceCreateTime"
              type="date"
              value-format="yyyy-MM-dd"
              :disabled="!isHnFlag"
              placeholder="选择日期"
            >
            </el-date-picker>
          </template>
        </vxe-table-column>
        <!-- 产品名称 -->
        <vxe-table-column
          width="180px"
          field="productName"
          :title="$t('outsidePrice.label.detailProductDisplayName')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="scope">
            <search-table
              v-model="scope.row.productName"
              searchType="goodsAll"
              :ref="'searchModal'"
              :isMultiple="true"
              :currentValue="scope.row.productName ? scope.row.productName : ''"
              :checkRowKeys="scope.row.productCode ? [scope.row.productCode] : []"
              @input="(val) => chooseTable(val, scope.row, 'productName', scope)"
            ></search-table>
          </template>
        </vxe-table-column>
        <!-- 业务部门 -->
        <vxe-table-column
          field="businessDepartmentName"
          width="120px"
          :title="$t('outsidePrice.label.businessDepartmentName')"
        ></vxe-table-column>
        <!-- 产品属性 -->
        <vxe-table-column
          field="productProperty"
          width="120px"
          :title="$t('outsidePrice.label.productProperty')"
          :edit-render="{
            type: 'visible',
            name: 'ElSelect',
            options: productPropertyList,
            props: { clearable: true },
          }"
        ></vxe-table-column>
        <!-- 货物状态 -->
        <vxe-table-column
          field="productStatus"
          width="120px"
          :title="$t('outsidePrice.label.productStatus')"
          :edit-render="{
            type: 'visible',
            name: 'ElSelect',
            options: productStatusList,
            props: { clearable: true },
          }"
        ></vxe-table-column>
        <!-- 价格类型 -->
        <vxe-table-column
          width="200px"
          field="externalPriceType"
          :title="$t('outsidePrice.label.externalPriceType')"
          :edit-render="{ type: 'visible', props: { clearable: true } }"
        >
          <template v-slot:edit="{ row }">
            <el-cascader
              :props="{ expandTrigger: 'hover' }"
              size="mini"
              v-model="row.externalPriceType"
              :options="externalPriceTypeList"
              @change="externalPriceTypeChange"
              clearable
            ></el-cascader>
          </template>
          <template v-slot="{ row }">{{
            getCascaderLabel(row.externalPriceType, externalPriceTypeList)
          }}</template>
        </vxe-table-column>
        <!-- 价格 -->
        <vxe-table-column
          field="priceValue"
          width="120px"
          :title="$t('outsidePrice.label.priceValue')"
          :edit-render="{ type: 'visible', name: 'input' }"
        >
          <template v-slot:edit="{ row }">
            <input-number
              style="width: 100%"
              v-model="row.priceValue"
              :max="99999999999.99"
              :precision="2"
              :clearable="true"
            ></input-number>
          </template>
        </vxe-table-column>
        <!-- 交易货币 -->
        <vxe-table-column
          field="tradeCurrencyCode"
          width="120px"
          :title="$t('outsidePrice.label.tradeCurrency')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="scope">
            <el-select
              filterable
              v-model="scope.row.tradeCurrencyCode"
              @change="$refs.table.updateStatus(scope)"
              clearable
            >
              <el-option
                v-for="item of tradeCurrencyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{
            getSelectLabel(row.tradeCurrencyCode, tradeCurrencyList)
          }}</template>
        </vxe-table-column>
        <!-- 交易市场 -->
        <vxe-table-column
          field="tradeMarket"
          width="120px"
          :title="$t('outsidePrice.label.tradeMarket')"
          :edit-render="{
            type: 'visible',
            name: 'ElSelect',
            options: tradeMarketList,
            props: { clearable: true },
          }"
        ></vxe-table-column>

        <!-- 供应商 -->
        <vxe-table-column
          v-if="isHnFlag"
          width="180px"
          field="partnerName"
          title="供应商"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="scope">
            <search-table
              v-model="scope.row.partnerName"
              searchType="supplier"
              :ref="'searchModal'"
              :isMultiple="true"
              :currentValue="scope.row.partnerName ? scope.row.partnerName : ''"
              :checkRowKeys="scope.row.partnerCode ? [scope.row.partnerCode] : []"
              @input="(val) => chooseTable(val, scope.row, 'partnerName', scope)"
            ></search-table>
          </template>
        </vxe-table-column>
        <!-- 表格按钮 -->
        <template v-slot:buttons>
          <vxe-button @click="addRow" type="primary" icon="el-icon-plus" class="vxe-btn-primary">{{
            $t('outsidePrice.btn.addRecord')
          }}</vxe-button>
          <vxe-button
            @click="deleteRow"
            type="primary"
            icon="el-icon-delete"
            class="vxe-btn-delete"
            >{{ $t('outsidePrice.btn.delRecord') }}</vxe-button
          >
        </template>
      </vxe-grid>
    </div>
    <footer class="fixed-bottom-btnList">
      <el-button class="fixed-bottom-btn" type="primary" @click="save">{{
        $t('outsidePrice.btn.save')
      }}</el-button>
    </footer>
  </div>
</template>

<script>
  // import * as rule from './rules';
  import { mapState } from 'vuex';
  import { dateFormat } from '@/filters';
  // import SearchModal from '@/components/SearchModal';
  import searchTable from '@/components/form-item/search-table';
  import API from '@/api/masterData/outsidePrice';
  import inputNumber from '@/components/form-item/input-number';
  import XEUtils from 'xe-utils';
  export default {
    name: 'addoutsidePrice',
    components: {
      // SearchModal,
      inputNumber,
      searchTable,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      tableRules() {
        const tradeMarketValid = (rule, value, callback, { row }) => {
          if (this.isHnFlag && ['WBJG02', 'WBJG04'].includes(row.externalPriceType[0])) {
            value ? callback() : callback(new Error('交易市场必填'));
          } else {
            callback();
          }
        };
        return {
          priceCreateTime: [{ required: true, message: '请选择日期' }],
          productName: [{ required: true, message: '请输入产品名称' }],
          businessDepartmentName: [{ required: true, message: '请输入业务部门' }],
          productProperty: [{ required: !this.isHnFlag, message: '请选择产品属性' }],
          productStatus: [{ required: !this.isHnFlag, message: '请选择货物状态' }],
          externalPriceType: [{ required: true, message: '请选择价格类型' }],
          priceValue: [{ required: true, message: '请输入价格' }],
          tradeCurrencyCode: [{ required: true, message: '请选择交易货币' }],
          tradeMarket: [
            { required: !this.isHnFlag, message: '请选择交易市场' },
            { validator: tradeMarketValid },
          ],
          partnerName: [{ required: this.isHnFlag, message: '请选择供应商' }],
        };
      },
      externalPriceTypeList() {
        // 价格类型下拉
        let dictType = this.isHnFlag ? 'external_price_type_hn' : 'external_price_type';
        let dictList = this.$baseRequest.getDictListMapByType(dictType) || [];
        if (dictList[0]) {
          dictList.forEach((item) => {
            // 添加年份
            if (item.value === 'WBJG04' || item.value === 'WBJG02') {
              item.children = this.yearsList;
              item.children.forEach((el) => {
                // 添加月份
                el.children = this.monthList;
              });
            }
          });
        }
        return dictList;
      },
    },
    data() {
      return {
        isHnFlag: false,
        activeIndex: null, // 激活行索引
        monthList: [],
        yearsList: [],
        tableData: [], // 表格数据
        tableToolbar: {},
        editConfig: {},
        productPropertyList: [], // 产品属性下拉
        productStatusList: [], // 货物状态下拉
        tradeCurrencyList: [], // 交易货币
        tradeMarketList: [], // 交易市场
        addRowObj: {
          // 新增行
          priceCreateTime: dateFormat(new Date()),
          businessDepartmentName: '', // 部门name
          businessDepartmentCode: '', // 部门code
          productName: '', // 自定义字段 => 展示父类or子类的名称
          productCode: '', // 自定义字段 =>
          productParentCode: '', // 父类code
          productParentName: '', // 父类name
          productDetailCode: '', // 子类code
          productDetailName: '', // 子类name
          externalPriceType: [], // 价格类型
          priceValue: '', // 价格
          productProperty: '', // 产品属性
          productStatus: '', // 货物状态
          tradeCurrencyCode: 'CNY', // 交易货币
          tradeCurrencyName: '中国人名币', // 交易货币名称
          tradeMarket: '', // 交易市场
          priceYear: '', // 年
          priceMonth: '', // 月
        },
        searchDialog: {
          API: API.LIST_PRODUCT_ALL,
          query: {
            productChName: null,
            adminFlag: null,
            selectCompanyCode: null,
            detailProductStatus: 'ZT03',
          },
          propName: 'detailProductDisplayName', // detailProductDisplayName || productChName
          searchColumns: [
            {
              prop: 'productChName',
              name: this.$t('outsidePrice.label.detailProductDisplayName'),
              type: 'input',
              placeholder: this.$t('outsidePrice.placeholder.detailProductDisplayName'),
              maxlength: '32',
            },
          ],
          columnList: [
            { prop: 'detailProductDisplayName', label: this.$t('outsidePrice.label.showName') },
            { prop: 'productChName', label: this.$t('outsidePrice.label.ZHName') },
            { prop: 'productDetailCode', label: this.$t('outsidePrice.label.productCode') },
            {
              prop: 'detailProductStatusName',
              label: this.$t('outsidePrice.label.productStatus_st'),
            },
          ],
        },
      };
    },
    mounted() {
      this.getMonthList();
      this.getyearsList();
      this.getDictList(); // 获取字典表值
      this.addRowObj.businessDepartmentName = this.userInfo.departmentName; // 部门信息
      this.addRowObj.businessDepartmentCode = this.userInfo.departmentCode;
      this.searchDialog.query.adminFlag = this.userInfo.adminFlag;
      this.searchDialog.query.selectCompanyCode = this.userInfo.companyCode;
      // 海宁默认价格类型
      let isHn = this.setIIsHnFlag();
      if (isHn) this.addRowObj.externalPriceType[0] = 'WBJG05';
      this.setData(); // 新建默认两行空数据
    },
    methods: {
      async setIIsHnFlag() {
        // 切换到海宁
        let res = await this.$baseRequest.getSysConfigByCompany({
          code: 'EXTERNAL_PRICE_HN',
          companyCode: this.userInfo.companyCode,
        });
        this.isHnFlag = res == 'Y' || false;
        return this.isHnFlag;
      },
      setData() {
        this.tableData.push(JSON.parse(JSON.stringify(this.addRowObj)));
        this.tableData.push(JSON.parse(JSON.stringify(this.addRowObj)));
      },
      // 新增行
      addRow() {
        this.tableData.push(JSON.parse(JSON.stringify(this.addRowObj))); // 避免新增行数据引用上一行
        this.$refs.table.setActiveRow(this.tableData[this.tableData.length - 1]); // 新增行激活
      },
      // 删除行
      deleteRow() {
        const selectedList = this.$refs.table.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('outsidePrice.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs.table.removeSelecteds().then(() => {
              this.tableData = this.$refs.table.getTableData().fullData;
            });
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('cooperation.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //表格下拉表格赋值
      chooseTable(val, row, field, scope) {
        const product = row[field] ? row[field][0] : null;
        //如果没有选产品 则不走下面的逻辑
        if (field == 'productName' && product) {
          row.productCode = product.productDetailCode || null;
          row.productName = product.detailProductDisplayName;
          row.productParentCode = product.parentProductNo; // 父类code
          row.productParentName = product.productChName; // 父类name
          row.productDetailCode = product.productDetailCode || null; // 子类code,子类不存在为null
          row.productDetailName = product.detailProductDisplayName || null; // 子类name,子类不存在为null
        }

        if (field == 'partnerName' && product) {
          row.partnerCode = product.partnerCode || null;
          row.partnerName = product.partnerZhName;
          row.partnerType = product.partnerType;
        }

        this.$refs.table.updateStatus(scope);
      },
      // 获取当前激活行索引
      getActiveIndex(value) {
        this.activeIndex = value.rowIndex;
      },
      // 价格类型改变
      externalPriceTypeChange(value) {
        const index = this.activeIndex;
        if (value[0] === 'WBJG02' || value[0] === 'WBJG04') {
          // 价格类型为期货
          let { productName, productParentName, productParentCode } = this.tableData[index];
          if (productName !== productParentName) {
            // 产品名称展示名称 !== 父类名称
            this.tableData[index].productName = productParentName; // 展示名称切换成父类name
            this.tableData[index].productCode = productParentCode; // 展示名称切换成父类code
            // this.$refs["searchModal"+index].defaultValue = productParentName;
          }
        } else {
          // 价格类型不是期货
          this.tableData[index].priceYear = '';
          this.tableData[index].priceMonth = '';
          let { productName, productDetailName, productDetailCode } = this.tableData[index];
          if (productDetailName && productName !== productDetailName) {
            // 子类存在 && 产品名称展示名称 !== 子类名称
            this.tableData[index].productName = productDetailName; // 展示名称切换成子类
            this.tableData[index].productCode = productDetailCode; // 展示名称切换成子类
            // this.$refs["searchModal"+index].defaultValue = productDetailName;
          }
        }
      },
      // 保存
      async save() {
        try {
          await this.$refs.table.validate();
          this.loading.startLoading();
          const tableData = JSON.parse(JSON.stringify(this.tableData));
          const { tenantCode, companyCode, departmentCode, companyName, departmentName } =
            this.userInfo;
          tableData.forEach((item) => {
            if (item.externalPriceType[0] === 'WBJG02' || item.externalPriceType[0] === 'WBJG04') {
              item.priceYear = item.externalPriceType[1];
              item.priceMonth = item.externalPriceType[2];
              item.externalPriceType = item.externalPriceType[0];
            } else {
              item.externalPriceType = item.externalPriceType[0];
            }
            item.tradeCurrencyName = this.tradeCurrencyList.find(
              (el) => el.value === item.tradeCurrencyCode
            ).label;
            item.tenantCode = tenantCode;
            item.companyCode = companyCode;
            item.departmentCode = departmentCode;
            item.companyName = companyName;
            item.departmentName = departmentName;
          });
          const params = {
            externalPriceDtos: JSON.stringify(tableData),
          };
          this.$axios.post(API.SAVE_OR_UPDATE_PRICE, params).then((res) => {
            this.loading.endLoading();
            if (res.data.code === 0) {
              this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              let path = {
                path: '/masterData/outsidePrice',
                name: 'outsidePrice',
                meta: {
                  keepAlive: false,
                  title: this.$t('outsidePrice.route.outsidePrice'),
                },
                query: {},
              };
              this.$store.dispatch('tagsView/addTabView', path).then(() => {
                this.$nextTick(() => {
                  this.$router.push(path);
                });
              });
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        } catch (errMap) {
          console.log(errMap);
        }
      },
      // 获取字典表值
      getDictList() {
        const tenantCode = this.userInfo.tenantCode; // 租户编码
        // 交易市场
        this.$axios.post(API.DICT_LIST, { dictType: 'trade_market', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            this.tradeMarketList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
        // 产品属性
        this.$axios
          .post(API.DICT_LIST, { dictType: 'product_property', tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.productPropertyList = res.data.data;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        // 货物状态
        this.$axios.post(API.DICT_LIST, { dictType: 'product_status', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            this.productStatusList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
        // 货币 (币种管理 )
        this.$axios.get(API.LIST_CURRENCY).then((res) => {
          if (res.data.code === 0) {
            this.tradeCurrencyList = [];
            res.data.data.forEach((item) => {
              let obj = {
                label: item.currencyName,
                value: item.currencyCode,
              };
              this.tradeCurrencyList.push(obj);
            });
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 12个月份下拉
      getMonthList() {
        for (var i = 1; i <= 12; i++) {
          let obj = {};
          obj.label = i + '月份';
          obj.value = i < 10 ? '0' + i.toString() : i.toString(); // 月份前加0
          this.monthList.push(obj);
        }
      },
      // 后五年的下拉
      getyearsList() {
        let year = new Date().getFullYear() - 1;
        for (var i = 0; i <= 5; i++) {
          year++;
          let obj = {};
          obj.label = year.toString() + '年';
          obj.value = year.toString();
          this.yearsList.push(obj);
        }
      },
      // vux-table 集成el-cascader回显方法
      getCascaderLabel(value, list) {
        let values = value || [];
        let labels = [];
        let matchCascaderData = function (index, list) {
          let val = values[index];
          if (list && values.length > index) {
            list.forEach((item) => {
              if (item.value === val) {
                labels.push(item.label);
                matchCascaderData(++index, item.children);
              }
            });
          }
        };
        matchCascaderData(0, list);
        return labels.join(' / ');
      },
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
    },
  };
</script>

<style scoped>
  .addoutsidePrice .footerBtn {
    margin-top: 20px;
    text-align: center;
  }
</style>
